"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabList_component_exports = {};
__export(TabList_component_exports, {
  TabList: () => TabList,
  default: () => TabList_component_default
});
module.exports = __toCommonJS(TabList_component_exports);
var import_react = __toESM(require("react"));
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_Tab = require("./Tab/Tab.component");
var import_ScreenReaderOnlyText = require("../../atoms/ScreenReaderOnlyText/ScreenReaderOnlyText.component");
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_debounce = __toESM(require("lodash/debounce"));
var import_react_i18next = require("react-i18next");
var import_TabList = require("./TabList.styled");
var import_LinkTab = require("./LinkTab/LinkTab.component");
var import_TabListContext = require("./TabListContext");
var _excluded = ["withBorder", "itemsAlignment", "role", "scrollable", "variant", "boldOnSelectedTab", "arrowButtonBackgroundColor", "fontSize"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var TabList = function TabList2(_ref) {
  var _props$children$, _props$children;
  var _ref$withBorder = _ref.withBorder, withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder, _ref$itemsAlignment = _ref.itemsAlignment, itemsAlignment = _ref$itemsAlignment === void 0 ? "left" : _ref$itemsAlignment, _ref$role = _ref.role, role = _ref$role === void 0 ? "tablist" : _ref$role, _ref$scrollable = _ref.scrollable, scrollable = _ref$scrollable === void 0 ? true : _ref$scrollable, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "light" : _ref$variant, _ref$boldOnSelectedTa = _ref.boldOnSelectedTab, boldOnSelectedTab = _ref$boldOnSelectedTa === void 0 ? false : _ref$boldOnSelectedTa, arrowButtonBackgroundColor = _ref.arrowButtonBackgroundColor, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? "small" : _ref$fontSize, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(void 0), _useState2 = _slicedToArray(_useState, 2), selectedTabId = _useState2[0], setSelectedTabId = _useState2[1];
  var _useState3 = (0, import_react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), tabIds = _useState4[0], setTabIds = _useState4[1];
  var wrapperTabList = (0, import_react.useRef)(null);
  var wrapperTabContainerList = (0, import_react.useRef)(null);
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), disabledLeftArrow = _useState6[0], setDisabledLeftArrow = _useState6[1];
  var _useState7 = (0, import_react.useState)(false), _useState8 = _slicedToArray(_useState7, 2), disabledRightArrow = _useState8[0], setDisabledRightArrow = _useState8[1];
  var maxScrollLeft = Number(wrapperTabList.current && wrapperTabList.current.scrollWidth);
  var scrollClient = Number(wrapperTabList.current && wrapperTabList.current.offsetWidth);
  var totalScroll = maxScrollLeft - scrollClient;
  var getRoundTotalScrolled = function getRoundTotalScrolled2() {
    return Math.floor(wrapperTabList.current && wrapperTabList.current.scrollLeft);
  };
  var _useState9 = (0, import_react.useState)(false), _useState10 = _slicedToArray(_useState9, 2), isResizeScroll = _useState10[0], setIsResizeScroll = _useState10[1];
  var _useState11 = (0, import_react.useState)(), _useState12 = _slicedToArray(_useState11, 2), containerScrollWidth = _useState12[0], setContainerScrollWidth = _useState12[1];
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  (0, import_react.useEffect)(function() {
    var _props$defaultSelecte;
    if (props !== null && props !== void 0 && (_props$defaultSelecte = props.defaultSelected) !== null && _props$defaultSelecte !== void 0 && _props$defaultSelecte.id) {
      setSelectedTabId(props.defaultSelected.id);
    }
  }, [props.defaultSelected]);
  (0, import_react.useEffect)(function() {
    var ids = import_react.Children.toArray(props.children).map(function(child) {
      return /* @__PURE__ */ (0, import_react.isValidElement)(child) && (child.type === import_Tab.Tab || child.type === import_LinkTab.LinkTab) ? child.props.id : void 0;
    });
    setTabIds(ids.filter(function(tabId) {
      return tabId !== void 0;
    }));
  }, [props.children]);
  (0, import_react.useEffect)(function() {
    if (getRoundTotalScrolled() === totalScroll && totalScroll !== 0 || maxScrollLeft === scrollClient && maxScrollLeft !== 0) {
      setDisabledRightArrow(true);
    } else {
      setDisabledRightArrow(false);
    }
    if (wrapperTabList.current && wrapperTabList.current.scrollLeft === 0) {
      setDisabledLeftArrow(true);
    } else {
      setDisabledLeftArrow(false);
    }
  }, [containerScrollWidth, selectedTabId]);
  var checkContainerScroll = function checkContainerScroll2() {
    var container = wrapperTabList === null || wrapperTabList === void 0 ? void 0 : wrapperTabList.current;
    var listContainer = wrapperTabContainerList === null || wrapperTabContainerList === void 0 ? void 0 : wrapperTabContainerList.current;
    if (container && listContainer) {
      setTimeout(function() {
        var listContainerWidth = listContainer.offsetWidth;
        var buttonKeys = container.querySelectorAll('button[role="tab"], div[role="combobox"], a');
        var sumTabsWidth = Array.from(buttonKeys).reduce(function(previousValue, currentValue) {
          return previousValue + currentValue.offsetWidth;
        }, 0);
        if (sumTabsWidth > listContainerWidth) {
          setIsResizeScroll(true);
        } else {
          setIsResizeScroll(false);
        }
        setContainerScrollWidth(listContainerWidth);
      }, 100);
    }
  };
  (0, import_react.useEffect)(function() {
    if (scrollable) {
      checkContainerScroll();
    }
  }, []);
  (0, import_useEventListener.useEventListener)("resize", function() {
    var debounceFn = (0, import_debounce.default)(checkContainerScroll, 200);
    if (scrollable) {
      debounceFn();
    }
  });
  var switchItem = function switchItem2(id, value) {
    setSelectedTabId(id);
    if (props.handleOnChange)
      props.handleOnChange(id, value);
  };
  var scrollOnKeyPress = function scrollOnKeyPress2(direction) {
    if (direction === "right") {
      var buttonItems = wrapperTabList.current.querySelectorAll('button[role="tab"], div[role="combobox"], a');
      var scrollPadding = 50;
      wrapperTabList.current.scrollLeft += scrollPadding;
      var scroll = wrapperTabList.current.scrollLeft;
      if ((scroll + scrollPadding > totalScroll || document.activeElement === buttonItems[buttonItems.length - 1]) && isResizeScroll) {
        wrapperTabList.current.scrollLeft = totalScroll;
        setDisabledRightArrow(true);
        setDisabledLeftArrow(false);
      } else {
        setDisabledLeftArrow(false);
        setDisabledRightArrow(false);
      }
      if (document.activeElement === buttonItems[0] && isResizeScroll) {
        wrapperTabList.current.scrollLeft = 0;
        setDisabledLeftArrow(true);
        setDisabledRightArrow(false);
      }
    } else {
      var _buttonItems = wrapperTabList.current.querySelectorAll('button[role="tab"], div[role="combobox"], a');
      var _scrollPadding = 50;
      wrapperTabList.current.scrollLeft -= _scrollPadding;
      setDisabledRightArrow(false);
      if (wrapperTabList.current && wrapperTabList.current.scrollLeft === 0 || document.activeElement === _buttonItems[0] && isResizeScroll) {
        wrapperTabList.current.scrollLeft = 0;
        setDisabledLeftArrow(true);
      }
      if (document.activeElement === _buttonItems[_buttonItems.length - 1] && isResizeScroll) {
        wrapperTabList.current.scrollLeft = totalScroll;
        setDisabledRightArrow(true);
        setDisabledLeftArrow(false);
      }
    }
  };
  var scrollBtn = function scrollBtn2(direction) {
    var scrollPadding = 50;
    var minRate = 2;
    if (direction === "right") {
      wrapperTabList.current.scrollLeft += scrollPadding;
      setDisabledLeftArrow(false);
      if (Math.abs(getRoundTotalScrolled() - totalScroll) < minRate) {
        setDisabledRightArrow(true);
      }
    } else {
      wrapperTabList.current.scrollLeft -= scrollPadding;
      setDisabledRightArrow(false);
      if (wrapperTabList.current && wrapperTabList.current.scrollLeft === 0) {
        setDisabledLeftArrow(true);
      }
    }
  };
  (0, import_useOnKeydown.useOnKeydown)(wrapperTabList, function(keyList) {
    var ArrowLeft = keyList.ArrowLeft, ArrowRight = keyList.ArrowRight, Home = keyList.Home, End = keyList.End, Space = keyList[" "];
    var buttonItems = wrapperTabList.current.querySelectorAll('button[role="tab"], div[role="combobox"], a');
    if (Home) {
      buttonItems[0].focus();
    }
    if (End) {
      buttonItems[tabIds.length - 1].focus();
    }
    if (Space) {
      if (!document.activeElement.getAttribute("aria-disabled")) {
        switchItem(document.activeElement.id);
      }
    }
    if (ArrowLeft) {
      var previousSibling = document.activeElement.previousElementSibling;
      if (previousSibling) {
        previousSibling.focus();
      } else {
        buttonItems[tabIds.length - 1].focus();
      }
      scrollOnKeyPress("left");
    }
    if (ArrowRight) {
      var nextSibling = document.activeElement.nextElementSibling;
      if (nextSibling) {
        nextSibling.focus();
      } else {
        buttonItems[0].focus();
      }
      scrollOnKeyPress("right");
    }
  });
  var childrenCount = import_react.Children.count(props.children);
  var isFirstTab = ((_props$children$ = props.children[0]) === null || _props$children$ === void 0 || (_props$children$ = _props$children$.props) === null || _props$children$ === void 0 ? void 0 : _props$children$.id) === selectedTabId;
  var isLastTab = ((_props$children = props.children[childrenCount - 1]) === null || _props$children === void 0 || (_props$children = _props$children.props) === null || _props$children === void 0 ? void 0 : _props$children.id) === selectedTabId;
  (0, import_react.useEffect)(function() {
    var positionContainerList = wrapperTabList.current.getBoundingClientRect();
    var selectedTab = document.getElementById(selectedTabId);
    var widthSelectedTab = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.offsetWidth;
    var position = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.getBoundingClientRect();
    var marginRate = 50;
    if ((position === null || position === void 0 ? void 0 : position.right) > (positionContainerList === null || positionContainerList === void 0 ? void 0 : positionContainerList.right) - marginRate) {
      wrapperTabList.current.scrollLeft += widthSelectedTab;
      setDisabledLeftArrow(false);
    }
    if ((position === null || position === void 0 ? void 0 : position.left) < (positionContainerList === null || positionContainerList === void 0 ? void 0 : positionContainerList.left) + marginRate) {
      wrapperTabList.current.scrollLeft -= widthSelectedTab;
      setDisabledRightArrow(false);
    }
    if (isLastTab)
      scrollBtn("right");
    if (isFirstTab)
      scrollBtn("left");
  }, [selectedTabId]);
  return /* @__PURE__ */ import_react.default.createElement(import_TabListContext.TabListContext.Provider, {
    value: {
      selectedTabId,
      handleOnSelect: switchItem
    }
  }, /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledTabListContainer, {
    colorVariant: variant,
    ref: wrapperTabContainerList,
    "data-testid": "container"
  }, isResizeScroll && scrollable && /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButtonContainerLeft, {
    arrowButtonBackgroundColor,
    colorVariant: variant,
    isHidden: disabledLeftArrow
  }, /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButtonWrapper, {
    arrowButtonBackgroundColor,
    colorVariant: variant
  }, /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButton, {
    tabIndex: -1,
    circle: true,
    "aria-label": t("base_action_scrollLeft_aria"),
    isHidden: disabledLeftArrow,
    icon: "arrow-drop-left",
    onClick: function onClick() {
      return scrollBtn("left");
    },
    variant: "empty",
    className: "scroller",
    size: "20px",
    dataDpAnalyticsId: props.prevButtonDataDpAnalyticsId,
    colorVariant: variant
  }, /* @__PURE__ */ import_react.default.createElement(import_ScreenReaderOnlyText.ScreenReaderOnlyText, {
    text: t("base_action_scrollLeft_aria")
  })))), /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledTabList, {
    "aria-label": props.ariaLabel,
    "data-testid": "tab-list-test-id",
    ref: wrapperTabList,
    role,
    scrollable,
    withBorder,
    itemsAlignment,
    isResizeScroll
  }, import_react.Children.map(props.children, function(child) {
    if (/* @__PURE__ */ (0, import_react.isValidElement)(child) && (child.type === import_Tab.Tab || child.type === import_LinkTab.LinkTab)) {
      if (role === "tablist" && child.type === import_LinkTab.LinkTab) {
        throw new Error(`Can't render LinkTab component inside TabList Component if role is not "navigation"`);
      }
      if (role === "navigation" && child.type === import_Tab.Tab) {
        throw new Error(`Can't render Tab component inside TabList Component if role is not "tablist"`);
      }
      return /* @__PURE__ */ (0, import_react.cloneElement)(child, {
        dataDpAnalyticsId: child.props.dataDpAnalyticsId || child.props.id,
        isBold: boldOnSelectedTab,
        fontSize
      });
    }
    return void 0;
  })), isResizeScroll && scrollable && /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButtonContainerRight, {
    arrowButtonBackgroundColor,
    colorVariant: variant,
    isHidden: disabledRightArrow
  }, /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButtonWrapper, {
    arrowButtonBackgroundColor,
    colorVariant: variant
  }, /* @__PURE__ */ import_react.default.createElement(import_TabList.StyledButton, {
    tabIndex: -1,
    circle: true,
    "aria-label": t("base_action_scrollRight_aria"),
    icon: "arrow-drop-right",
    onClick: function onClick() {
      return scrollBtn("right");
    },
    variant: "empty",
    className: "scroller",
    size: "20px",
    isHidden: disabledRightArrow,
    dataDpAnalyticsId: props.nextButtonDataDpAnalyticsId,
    colorVariant: variant
  }, /* @__PURE__ */ import_react.default.createElement(import_ScreenReaderOnlyText.ScreenReaderOnlyText, {
    text: t("base_action_scrollRight_aria")
  }))))));
};
TabList.displayName = "TabList";
TabList.Tab = import_Tab.Tab;
TabList.LinkTab = import_LinkTab.LinkTab;
var TabList_component_default = TabList;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  TabList
});
//# sourceMappingURL=TabList.component.js.map